import moment from "moment-timezone";

export const isWithin = (timeRange, precision = "second") => {
  const { start, end } = timeRange || {};
  if (!start || !end) {
    return false;
  }

  const now = moment(); // Uses the default timezone set in app.js
  return now.isBetween(moment(start), moment(end), precision, "[]");
};

export const formatTime = (date, formatString = "YYYY-MM-DD HH:mm:ss") => {
  return moment(date).format(formatString); // Uses the default timezone
};
